const checkSingleCondition = (specifiedValue: string[], conditionValue: string | string[]) => {
  if (Array.isArray(conditionValue)) {
    return (conditionValue as string[]).some(value => (specifiedValue as string[]).includes(value));
  } else {
    return (specifiedValue as string[]).includes(conditionValue);
  }
};

// Conditions for different fields are always linked with a logical AND.
// Multiple values specified for the same field are linked with a logical OR
// (meaning one matching value is enough, which makes sense because you can't
// have e.g. multiple carriers or payment methods selected at the same time)
const checkCondition = (
  condition?: Record<string, string[] | number>,
  conditionValues?: Record<string, string | string[] | number>
) =>
  !condition ||
  !Object.keys(condition).length ||
  Object.entries(condition).reduce<boolean>(
    (acc, [conditionField, specifiedValue]) =>
      acc &&
      (conditionField === 'minBasketTotal' ?
        conditionValues?.basketTotal ?
          conditionValues.basketTotal >= specifiedValue
        : false
      : checkSingleCondition(specifiedValue as string[], conditionValues?.[conditionField] as string | string[])),
    true
  );

export default checkCondition;
